export const SWITCH_THEME = "SWITCH_THEME"
export const SET_PREVIOUS_ROUTE = "SET_PREVIOUS_ROUTE"
export const themeAction = theme => {
    return dispatch => {
        dispatch({
            type: SWITCH_THEME,
            theme: theme
        })
    }
}

export const setPreviousRouteAction = (details) => {
    return({
        type: SET_PREVIOUS_ROUTE,
        payload: details,
      })
   };